/**
 * Section A split-pane tag on LNAT rows. Studio schema and import both
 * use `requires_exhibit`. exhibit_text is the left-pane HTML.
 */
export function lnatSectionAHasSplitTag(question) {
  if (question?.requires_exhibit === true) return true;
  return String(question?.exhibit_text || '').trim().length > 0;
}

/**
 * Split pane only for LNAT Section A when the split tag is set and
 * exhibit_text is non-empty. Never the leftover pearson always-split
 * Passage pane. Explicit requires_exhibit=false opts out.
 */
export function shouldSplitLnatPearsonItem(examName, phaseOrSection, question) {
  if (String(examName || '').toLowerCase() !== 'lnat') return false;
  const section = String(phaseOrSection || '').toLowerCase();
  const isB = section === 'b'
    || section === 'section_b'
    || section === 'section b'
    || section === 'p2'
    || section === 'p2_items'
    || section === 'p2_review'
    || section === 'p2_instructions'
    || Number(question?.tmuaPaper) === 2;
  if (isB) return false;
  const isA = section === 'a'
    || section === 'section_a'
    || section === 'section a'
    || section === 'p1'
    || section === 'p1_items'
    || section === '1'
    || Number(question?.tmuaPaper) === 1;
  if (!isA) return false;
  const exhibit = String(question?.exhibit_text || '').trim();
  if (!exhibit) return false;
  if (question?.requires_exhibit === false) return false;
  return true;
}

export function usesLeftoverPearsonLayout(examMode, pearsonPlayer) {
  return examMode === 'pearson' && !pearsonPlayer;
}
